// helper.ts
import { cva } from "class-variance-authority";

export const dropdownMenuStyles = cva(
  [
    "relative",
    "cursor-pointer",
    "inline-flex",
    "items-center",
    "justify-between",
    "min-w-0",
    "h-[2.125rem]",
    "px-2.5",
    "py-1.5",
    "gap-2",
    "rounded-lg",
    "transition-colors",
    "duration-200",
    "ease-linear",
    "disabled:cursor-not-allowed",
    "disabled:opacity-60",
  ],
  {
    variants: {
      variant: {
        primary:
          "border border-neutral-200 bg-white text-neutral-300 hover:bg-neutral-50 focus:border-primary-800",
        secondary:
          "border border-neutral-200 bg-white text-neutral-300 hover:bg-neutral-50 focus:border-primary-800",
      },
      position: {
        bottomright: "",
        bottomleft: "",
        bottomcenter: "",
        topright: "",
        topleft: "",
        topcenter: "",
      },
    },
    defaultVariants: {
      variant: "primary",
      position: "bottomleft",
    },
  },
);

export const dropdownPositionStyles = cva(
  [
    "absolute",
    "z-[1000]", // ✅ sensible z-index (don’t go 999999)
    "rounded-lg",
    "border border-neutral-200",
    "bg-white",
    "shadow-lg",
    "p-1",
    "w-max",
    "min-w-full",
    "max-h-64", // ✅ only scroll if too tall
    "overflow-auto",
  ].join(" "),
  {
    variants: {
      position: {
        bottomright: "top-full right-0 mt-1",
        bottomleft: "top-full left-0 mt-1",
        bottomcenter: "top-full left-1/2 -translate-x-1/2 mt-1",
        topright: "bottom-full right-0 mb-1",
        topleft: "bottom-full left-0 mb-1",
        topcenter: "bottom-full left-1/2 -translate-x-1/2 mb-1",
      },
    },
    defaultVariants: {
      position: "bottomleft",
    },
  },
);

export const dropdownPanelStyles = cva([
  "z-[1000]",
  "bg-white",
  "border",
  "border-neutral-200",
  "shadow-lg",
  "p-1",
  "rounded-lg",
  "flex",
  "flex-col",
  "gap-1",
]);
